import * as React from "react"

const SvgCalendarDollar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.597 21.841q.587.587 1.412.587h7a.97.97 0 0 0 .713-.287.97.97 0 0 0 .287-.712.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.288h-7v-10h14v1.025q0 .426.288.713a.96.96 0 0 0 .712.287.97.97 0 0 0 .713-.287.97.97 0 0 0 .287-.713V6.43a1.93 1.93 0 0 0-.587-1.413 1.93 1.93 0 0 0-1.413-.587h-1v-1a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713v1h-8v-1a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713v1h-1q-.824 0-1.412.587a1.93 1.93 0 0 0-.588 1.413v14q0 .825.588 1.412ZM19.009 8.429h-14v-2h14z"
      clipRule="evenodd"
    />
    <path d="M17.806 23.428a.69.69 0 0 1-.487-.198.67.67 0 0 1-.21-.505v-.199a3.3 3.3 0 0 1-1.23-.604 2.86 2.86 0 0 1-.811-.986.72.72 0 0 1 .008-.627.77.77 0 0 1 .487-.428.9.9 0 0 1 .61 0q.303.108.52.413.246.337.58.52.331.183.61.183.542 0 .843-.252.302-.253.302-.573 0-.352-.348-.635t-1.183-.543q-1.255-.428-1.81-1.001-.557-.575-.557-1.46 0-.69.48-1.338.48-.65 1.5-.88v-.183a.68.68 0 0 1 .2-.505.66.66 0 0 1 .48-.199q.294 0 .48.2a.7.7 0 0 1 .186.504v.183q.51.123.951.375t.735.68q.2.29.085.62a.76.76 0 0 1-.456.466.88.88 0 0 1-.55.008q-.3-.084-.657-.36a.9.9 0 0 0-.364-.206 1.5 1.5 0 0 0-.44-.069q-.434 0-.689.184-.255.183-.255.443 0 .29.31.55.309.261 1.391.627 1.13.383 1.664.971.533.589.533 1.568a2.18 2.18 0 0 1-.634 1.552q-.634.665-1.624.848v.153a.7.7 0 0 1-.194.505.62.62 0 0 1-.456.198" />
  </svg>
)
export default SvgCalendarDollar
